import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box, CircularProgress } from "@mui/material"

import { getProduct2skill2exp2rateStruct, setData } from './Product2skill2exp2rateStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './Product2skill2exp2rateAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import { updateProduct2skill2exp2rateObj, addProduct2skill2exp2rateObj, setShowEditForProduct2skill2exp2rate } from 'store/slice/ManufSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';

import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import MfpartyList from '../mfparty/MfpartyList';

export default function Product2skill2exp2rateEditFormImpl() {
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getProduct2skill2exp2rateStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [supplierList, setSupplierList] = useState([]);

    const { product2skill2exp2rateDashboard } = useSelector((state) => state.manufslice);
    const {product2skill2exp2rateObj} = useSelector((state) => state.manufslice.product2skill2exp2rateDashboard);
    const [product2skill2exp2rateId, setProduct2skill2exp2rateId] = useState(product2skill2exp2rateDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo);
    const { mfpartyList } = useSelector((state) => state.manufslice);

    const { skillList } = useSelector((state) => state.manufslice);
    const handleDynamicSelectedValueForskillid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'skillname', e.target.value == 0 ? 'Select Item' : skillList.find(obj => obj.id === e.target.value).title);
    }
    const { mfproductList } = useSelector((state) => state.manufslice);
    const handleDynamicSelectedValueForproductid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'productname', e.target.value == 0 ? 'Select Item' : mfproductList.find(obj => obj.id === e.target.value).title);
    }
    const { workerList } = useSelector((state) => state.manufslice);

    const combinedList = [
        ...(workerList || []),
        ...(mfpartyList.filter(partyObj => partyObj.stocker) || [])
    ];

    const handleDynamicSelectedValueForworkerid = (e) => {
        updateSelectedValue(
            formValues,
            setFormValues,
            e,
            'workername',
            e.target.value == 0
                ? 'Select Item'
                : combinedList.find(obj => obj.id === e.target.value)?.title
        );
    };

    const { apiInProgress } = useSelector((state) => state.headerslice)
    useEffect(() => {
    }, [apiInProgress])

    useEffect(() => {
        setSupplierList(mfpartyList.filter(partyObj => partyObj.stocker));
        console.log("supplierList: ", mfpartyList.filter(partyObj => partyObj.stocker));

        if (product2skill2exp2rateId !== -1) {
            if (dataLoaded) return;
            getAPI(product2skill2exp2rateId, loadForm);
        }
        else {
            // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            }, ['skillid']: {
                ...formValues['skillid'],
                value: skillList[0].id
            }, ['skillname']: {
                ...formValues['skillname'],
                value: skillList[0].title
            }, ['workerid']: {
                ...formValues['workerid'],
                value: product2skill2exp2rateObj.workerid
            }
        })
    }, []);
    useEffect(() => {
        // if(!formValues.typeid.value)
        // setFormValues({
        //     ...formValues,
        //     ['workerid']: {
        //         ...formValues['workerid'],
        //         value: 0
        //     }
        // });

    }, [formValues.typeid.value]);

    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data) => {
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value + " == " + getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Remove newlines for the description field
        const sanitizedValue = value.replace(/[\r\n]+/g, '')
        updateTextValue(formValues, setFormValues, { target: { name, value: sanitizedValue } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;

        // Do not allow starting with '.'
        if (value.startsWith('.')) {
            return;
        }

        // Allow empty string so user can delete all characters
        if (value === '' || value === '.') {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
            return;
        }

        // Regex: Allow up to 9 digits before decimal, optional decimal, up to 2 digits after decimal (Indian Rupees format)
        const regex = /^\d{0,9}(\.\d{0,2})?$/;

        if (regex.test(value)) {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
        }
    }
    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(addProduct2skill2exp2rateObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForProduct2skill2exp2rate(false));
    }
    const updateSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateProduct2skill2exp2rateObj(obj));
        setNotification('Record with id[' + product2skill2exp2rateId + '] has been updated successfully !!!');
        dispatch(setShowEditForProduct2skill2exp2rate(false));

    }
    const failuerCallback = (errorMsg) => {
        dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) => {
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id, formValues, updateSuccessCallback, failuerCallback) => {
        dispatch(setApiInProgress(true));
        updateAPI(id, formValues, updateSuccessCallback, failuerCallback);
    }
    const onSubmit = (e) => {
        handleSubmit(e, product2skill2exp2rateId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);

        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr = date.getFullYear() + "-" + monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '58vh' }}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{product2skill2exp2rateId === -1 ? 'Add' : 'Edit'} Worker Rate </Typography>
                                <Divider />
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded ?
                                <Grid container display="flex" direction="row" justifyContent="space-between" alignItems="flex-start" >
                                    <Grid item lg={4} xs={12} sx={{ backgroundColor: 'secondary.100', borderRadius: 1, p:1 }}>
                                        <Grid container direction="column">
                                            <Grid item>
                                                <FormControl sx={{ width: '100%', pl: 1 }}>
                                                    <FormLabel>Type</FormLabel>
                                                    <RadioGroup
                                                        row
                                                        name="typeid"
                                                        value={formValues.typeid.value}
                                                        onChange={e => updateValue(formValues, setFormValues, 'typeid', e.target.value)}
                                                    >
                                                        <FormControlLabel
                                                            value="0"
                                                            control={<Radio />}
                                                            label="Worker"
                                                        />
                                                        <FormControlLabel
                                                            value="1"
                                                            control={<Radio />}
                                                            label="Supplier"
                                                        />
                                                    </RadioGroup>
                                                    {formValues.typeid.error && (
                                                        <Typography color="error" variant="caption">{formValues.typeid.errorMessage}</Typography>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item sx={{ p: 1, }}>
                                                <FormControl sx={{ width: '100%' }} size="Normal">
                                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.typeid.value==0? 'Worker' : 'Supplier'}</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-autowidth-label"
                                                        id="demo-simple-select-autowidth"
                                                        label="Worker"
                                                        name={formValues.workerid.name}
                                                        value={formValues.workerid.value}
                                                        onChange={handleDynamicSelectedValueForworkerid}

                                                        error={formValues.workerid.error}
                                                        helpertext={formValues.workerid.error && formValues.workerid.errorMessage}
                                                    >
                                                        <MenuItem key={0} value="0">Select Item</MenuItem>
                                                        {
                                                            formValues.typeid.value == 0 ? workerList && workerList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) :
                                                                supplierList && supplierList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                        </Grid>


                                    </Grid>
                                    <Grid item lg={7} xs={12} sx={{ backgroundColor: 'secondary.100', borderRadius: 1, p:2 }}>
                                        <Grid container direction="column">
                                                <Grid item lg={12} xs={12}>
                                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                                        <InputLabel id="demo-simple-select-autowidth-label">Product</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-autowidth-label"
                                                            id="demo-simple-select-autowidth"
                                                            label="Product"
                                                            name={formValues.productid.name}
                                                            value={formValues.productid.value}
                                                            onChange={handleDynamicSelectedValueForproductid}

                                                            error={formValues.productid.error}
                                                            helpertext={formValues.productid.error && formValues.productid.errorMessage}
                                                        >
                                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                                            {
                                                                mfproductList && mfproductList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item lg={12} xs={12} sx={{ pt: 2 }}>
                                                    <TextField size="Normal"
                                                        placeholder={formValues.rate.placeholder}
                                                        required={formValues.rate.required}
                                                        label={formValues.rate.label}
                                                        name={formValues.rate.name}
                                                        value={formValues.rate.value}
                                                        onChange={handleDoubleChange}
                                                        error={formValues.rate.error}
                                                        helperText={formValues.rate.error && formValues.rate.errorMessage}
                                                        sx={{ width: '100%' }}
                                                    />
                                                </Grid>
                                            
                                        </Grid>
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">{formValues.skillid.label}</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label={formValues.skillid.label}
                                                name={formValues.skillid.name}
                                                value={formValues.skillid.value}
                                                onChange={handleDynamicSelectedValueForskillid}

                                                error={formValues.skillid.error}
                                                helpertext={formValues.skillid.error && formValues.skillid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                {
                                                    skillList && skillList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.skillname.placeholder}
                                            required={formValues.skillname.required}
                                            label={formValues.skillname.label}
                                            name={formValues.skillname.name}
                                            value={formValues.skillname.value}
                                            onChange={handleTextChange}
                                            error={formValues.skillname.error}
                                            helperText={formValues.skillname.error && formValues.skillname.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>


                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.productname.placeholder}
                                            required={formValues.productname.required}
                                            label={formValues.productname.label}
                                            name={formValues.productname.name}
                                            value={formValues.productname.value}
                                            onChange={handleTextChange}
                                            error={formValues.productname.error}
                                            helperText={formValues.productname.error && formValues.productname.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>




                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.workername.placeholder}
                                            required={formValues.workername.required}
                                            label={formValues.workername.label}
                                            name={formValues.workername.name}
                                            value={formValues.workername.value}
                                            onChange={handleTextChange}
                                            error={formValues.workername.error}
                                            helperText={formValues.workername.error && formValues.workername.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%', }}
                                        />
                                    </Grid>
                                </Grid>
                                : <></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider />
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    {apiInProgress ? <CircularProgress /> :
                        <>
                            <Button variant="outlined" type="submit" >{product2skill2exp2rateId === -1 ? 'Add' : 'Save'}</Button>&nbsp;&nbsp;&nbsp;
                            <Button variant="outlined" onClick={() => { dispatch(setShowEditForProduct2skill2exp2rate(false)); }}>Close</Button>
                        </>
                    }
                </Grid>
            </Grid>
        </form>
    );
};